var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "#1F1F1F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.3333 46.9L58.6333 15.3C54.0333 10.7 46.5333 10.7 42.0333 15.3L10.3333 46.9C9.33325 47.9 9.33325 49.5 10.3333 50.5C11.3333 51.5 12.9333 51.5 13.9333 50.5L15.9333 48.5V80.8C15.9333 84.8 19.2333 88.1 23.2333 88.1H40.1333H60.5333H77.3333C81.3333 88.1 84.6333 84.8 84.6333 80.8V48.5L86.6333 50.5C87.1333 51 87.7333 51.2 88.4333 51.2C89.1332 51.2 89.7333 51 90.2333 50.5C91.3333 49.5 91.3333 47.9 90.3333 46.9ZM57.9333 83.1H42.7333V63C42.7333 61.4 44.0333 60.1 45.6333 60.1H55.1333C56.7332 60.1 58.0333 61.4 58.0333 63V83.1H57.9333ZM79.6333 80.9C79.6333 82.1 78.6332 83.1 77.4333 83.1H63.0333V63C63.0333 58.6 59.4333 55 55.0333 55H45.5333C41.1333 55 37.5333 58.6 37.5333 63V83H23.3333C22.1333 83 21.1333 82 21.1333 80.8V43.4L45.6333 18.9C48.2332 16.3 52.4333 16.3 55.0333 18.9L79.5332 43.4V80.9H79.6333Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7a8baa591dcc7406c597659fd8b25009.svg";
export { ForwardRef as ReactComponent };